import Giveaway from 'components/Giveaway';
import sessionStore from 'utils/sessionStore';
import React from 'react';
const { useEffect } = React;

export default function THEWHOOgiveaway() {
  useEffect(() => {
    sessionStore.setReferralCode('SORRAWHOO');
  }, []);
  return (
    <Giveaway
      desktopBanner="/images/membership/thewhoo/banner_desktop.jpeg"
      mobileBanner="/images/membership/thewhoo/banner_mobile.jpeg"
    />
  );
}
